import { IconButton } from "@mui/material";
import EventIcon from '@mui/icons-material/Event';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React, { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  dateButton: {
    position: 'absolute',
    top: '10%',
    right: '13%',
    zIndex: '1000',
  },
}));

export default function CalendarIconDatePicker({ value, onChange, title }: {
  value: string,
  onChange: (arg0: any) => any
  title: string,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        id={`calendar-icon-button-${title}`}
        className={classes.dateButton}
      >
        <EventIcon/>
      </IconButton>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          open={open}
          views={['year']}
          label="Year"
          onClose={() => setOpen(false)}
          value={value}
          onChange={onChange}
          slotProps={{
            popper: {
              anchorEl: document.getElementById(`calendar-icon-button-${title}`), // Anchor the position to be at the Icon
              placement: 'bottom-start'
            },
            textField: {
              InputProps: { style: { display: 'none' } }, // Hide the input field
            },
          }}
        />
      </LocalizationProvider>
    </>
  );
}
